import '@utils/jsExtentions';
import '@fontsource/roboto/latin.css';
import '@fontsource/noto-sans-hebrew/hebrew.css';
import '@fontsource/material-symbols-outlined';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './i18n';

import * as Sentry from '@sentry/react';

Sentry.init({
    dsn: 'https://026be9343951cbff52d667ef8c049057@o4506807305043968.ingest.us.sentry.io/4511244915245056',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [Sentry.replayIntegration()],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
